// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_1qgBVZFWaV0n3T5jL4mkvy","leftContainer":"_3TfhbtoJXTUJAhSa5IKrxN","leftTopBar":"_3n5Io1BCNPEzHz9Pou_yvn","leftBottomContainer":"emJKqmTmBt8yrGK2UwoVK","videoPlayerContainer":"_2teEW1-5GA2LgnKEMlHKFv","advertiseContainer":"_3BwU8K5tYVyLnvc49oQyIM","advertise":"_1Y4OY1kkGWiOPiUMxgL76I","advertIframe":"_1g5VVPcItBOzJevLbPLOVU","rightContainer":"U2XrTSWU6ZfNbV8A0UYl0","centerContainer":"qW87RJ5sFbhaF8stnEkhL","rightTopBarContainer":"_3VNdqBgq0AniI2TCa-wTkG","rightContentContainer":"_3eoVFqOBw0gzasjWD9D0SC","rightBottomBarContainer":"_2N0byi6vT2B6CRyNXkucr-"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/desktop/css/main.css
// module id = 1039
// module chunks = 0